<main id="error">
  <section>
    <article>
      <h1 translate>notFound.title</h1>
      <img src="/assets/img/404.svg" alt="">
      <p><p translate>notFound.message<a [routerLink]="['/']" translate>notFound.link</a></p>
    </article>
  </section>
</main>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/not-found/not-found.component.html